import { render, staticRenderFns } from "./applied-risk-value-badge.vue?vue&type=template&id=e6c6d5f8&scoped=true"
import script from "./applied-risk-value-badge.vue?vue&type=script&lang=js"
export * from "./applied-risk-value-badge.vue?vue&type=script&lang=js"
import style0 from "./applied-risk-value-badge.vue?vue&type=style&index=0&id=e6c6d5f8&prod&lang=scss&scoped=true"
import style1 from "./applied-risk-value-badge.vue?vue&type=style&index=1&id=e6c6d5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6d5f8",
  null
  
)

export default component.exports